/* global window */
import '../styles/NavigationDropdownMenu.css';
import { array, number, oneOfType, shape, string } from 'prop-types';
import { FaChevronDown } from 'react-icons/fa';
import Nav from 'react-bootstrap/Nav';
import React, { forwardRef, useRef } from 'react';
import { Link } from 'react-router-dom';


/** CONFIGURATION */
/**
 * @constant {number} DEFAULT_MAX_CHILD_ITEMS
 * The default maximum number of child items to display when the
 * `maxChildItemsToDisplay` property is not set or is zero.
 */
const DEFAULT_MAX_CHILD_ITEMS = 8;
/**
 * @constant {boolean} USE_DEFAULT_LIMIT
 * Determines whether to use the default limit for the number of child items to
 * display or display all children when the `maxChildItemsToDisplay` property
 * is not set or is zero.
 */
const USE_DEFAULT_LIMIT = true;

const NavigationDropdownMenu = forwardRef(({ navLink }, ref) => {
    const toggleRef = useRef(null);
    const currentUrl = window.location.pathname;

    return (<div
        className={`nav-dropdown-menu--container ${currentUrl.includes(navLink.title.split(' ').join('-')) ? 'active' : ''}`}
        ref={ref}>
        <Nav.Link
            as={Link}
            ref={toggleRef}
            to={navLink.url}>
            {navLink.title}
            {navLink.children?.length > 0 && <FaChevronDown />}
        </Nav.Link>
    </div>);
});

NavigationDropdownMenu.defaultProps = {};
NavigationDropdownMenu.displayName = 'NavigationDropdownMenu';
NavigationDropdownMenu.propTypes = {
    navLink: shape({
        children: array,
        id: oneOfType([number, string]),
        title: string,
    }),
};

export default NavigationDropdownMenu;